<template>
  <div class="module-action">
    <main class="module-action" v-if="totalSelections > 0">
      <span class="mb-5" style="opacity:0.7"><i class="cui-task icons font-5xl d-block"></i></span>
      <h5>{{totalSelections}} birthday group(s) selected</h5>
      <p class="mb-3"><a href="javascript:void()" @click="allBirthdayGroupSelections(true)" class="small">Click here to select all birthday groups</a></p>
      <p style="display:block"><a class="action-buttion" @click="deleteSelectedBirthdayGroups()" href="javascript:void()"><span class="mb-5"><i class="icon-trash icons font-1xl"></i> Delete</span></a></p>
      <p style="display:block"><a class="action-buttion" @click="allBirthdayGroupSelections(false)" href="javascript:void()"><span class="mb-5"><i class="icon-close icons font-1xl"></i> Cancel</span></a></p>
    </main>
    <main class="module-action" v-else>
      <span class="mb-5" style="opacity:0.7"><i class="icon-layers icons font-5xl d-block"></i></span>
      <h5>Select an item from <strong>{{total}}</strong> birthday group(s) for more details</h5>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import VueSweetalert2 from 'vue-sweetalert2';
 
Vue.use(VueSweetalert2);

export default {
  name: 'BirthdayGroupAction',
  components: {
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    totalSelections: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
  },
  computed: {
  },
  methods: {
    allBirthdayGroupSelections: function(flag) {
      this.$emit('all-birthday-group-selections', flag)
    },
    deleteSelectedBirthdayGroups: function() {
      this.$swal({
        title: "Delete birthday group",
        text: "Sure you want to delete selected birthday group(s)?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete them!"
      }).then((result) => { 
        this.$emit('delete-birthday-group-selections', true)
      })
    },
  }
}
</script>
